import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ITerms} from "../models/iterms.model";
import {IPhoto} from "../models/iphoto.model";
import {IStudent} from '../models/istudent.model';

@Injectable({
  providedIn: 'root'
})
export class CallTimeticketService {

  constructor(private _http: HttpClient) {
  }

  getActiveTerms(pidm: string) {
    return this._http.get<Array<ITerms>>('api/TimeTicket/GetActiveTerms', {
      params: {
        pidm: pidm
      }
    });
  }

  getTimeTicket(pidm: string, term: string) {
    return this._http.get('api/TimeTicket/GetTimeTicket', {
      params: {
        pidm: pidm,
        term: term
      }, responseType: 'text'
    });
  }

  getPhoto(pidm: string) {
    return this._http.get<IPhoto>('api/General/GetPhoto', {
      params: {
        pidm: pidm
      }
    });
  }

  getStudentInfo(pidm: string) {
    return this._http.get<IStudent>('api/General/GetStudentInfo', {
      params: {
        pidm: pidm
      }
    });
  }
}
